import React from 'react';
import { debounce } from 'lodash';

import AsyncSelect from 'components/AsyncSelect';
import AsyncSelectItem from 'components/AsyncSelectItem';
import BoxBody from 'components/BoxBody';
import Label from 'components/Label';
import Text from 'components/Text';
import { CoachRow } from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorPeopleListView';

export type Props = {
  onNextPage: () => Promise<void>;
  hasNextPage?: boolean;
  coaches?: CoachRow[];
  onSelectCoach: (coachItem: React.ReactElement) => void;
  validStatuses: string[];
};

export default function CoachingCoordinatorCoachSelect(props: Props) {
  const renderCoachItems = (input: string) => {
    const activeCoaches = (props.coaches ?? []).filter(
      coach =>
        coach.name.toLowerCase().includes(input.toLowerCase()) &&
        props.validStatuses.includes(coach.status)
    );
    return (
      activeCoaches.map(coach => (
        <AsyncSelectItem title={coach.name} id={coach.uuid}>
          <BoxBody size="xxsmall">
            <Text align="left">{coach.name}</Text>
          </BoxBody>
        </AsyncSelectItem>
      )) ?? []
    );
  };

  const searchCoaches = debounce(
    (input: string, callback: (promise: Promise<React.ReactElement[]>) => void) => {
      if (props.hasNextPage) {
        callback(props.onNextPage().then(() => renderCoachItems(input)));
      } else {
        callback(Promise.resolve().then(() => renderCoachItems(input)));
      }
    },
    300
  );

  return (
    <React.Fragment>
      <Label>Coach</Label>
      <AsyncSelect
        data-test="coach-async-select"
        initialItems={renderCoachItems('')}
        infiniteLoad
        noResults={<>No coaches found</>}
        placeholder="Search for a coach"
        searchCallback={searchCoaches}
        onSelect={props.onSelectCoach}
      />
    </React.Fragment>
  );
}
